<template>
  <generic-modal :title="$t('requested trips')" ref="generic_modal">
    <!-- <div class="form">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("destination") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.destination" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('driver')"
              :is_multiple="false"
              :placeholder="$t('driver')"
              url="/trip/driver/catalog"
              name_field="name"
              value_field="driver_id"
              @selected="set_driver"
              ref="driver_dropdown"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("departure date") }}</label>
            <div class="control">
              <input class="input" type="date" v-model="meta.departure_date" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("return date") }}</label>
            <div class="control">
              <input class="input" type="date" v-model="meta.return_date" />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="grid">
      <div class="cell" v-for="(itm, iidx) in meta" :key="iidx">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              <span class="icon">
                <i class="fa fa-user"></i>
              </span>
              <span>{{ itm.name }} </span>
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <div class="title is-5">
                <span class="icon">
                  <i class="fa fa-map-marker"></i>
                </span>
                <span>{{ itm.origin }}</span>
                <span class="icon">
                  <i class="fa fa-arrow-right"></i>
                </span>
                <span>{{ itm.destination }}</span>
              </div>
              <div class="subtitle is-6 mb-0">
                <span class="icon">
                  <i class="fa fa-calendar"></i>
                </span>
                <span>{{ format_date_time(itm.date) }}</span>
              </div>
              <div class="subtitle is-6 mb-0">
                <span class="icon">
                  <i class="fa fa-users"></i>
                </span>
                <span>{{ itm.passenger_number }}</span>
              </div>
              <div class="subtitle is-6 mb-0">
                <span class="icon">
                  <i class="fa fa-briefcase"></i>
                </span>
                <span>{{ itm.luggage_number }}</span>
              </div>

              <!-- <pre>{{ itm }}</pre> -->
              <div class="field">
                <generic-dropdown
                  :title="$t('trip')"
                  :is_multiple="false"
                  :placeholder="$t('trip')"
                  url="/trip/scheduled/catalog"
                  name_field="title"
                  value_field="trip_id"
                  @selected="assign_to_trip(itm, $event)"
                  ref="trip_dropdown"
                  :add_new="true"
                  @add_new="add_new_trip(itm, $event)"
                  :extra_data="{
                    date: itm.date,
                    origin: itm.origin,
                    destination: itm.destination,
                  }"
                />
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <!-- <a href="#" class="card-footer-item">Edit</a> -->
            <a href="#" class="card-footer-item">
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
              <span>{{ $t("delete") }}</span>
            </a>
            <a href="#" class="card-footer-item">
              <span class="icon">
                <i class="fa fa-dont"></i>
              </span>
              <span>{{ $t("reject") }}</span>
            </a>
          </footer>
        </div>
      </div>
      <!-- <pre>{{ meta }}</pre> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
    <event-modal ref="event_modal" />
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_date_time,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import moment from "moment";
import EventModal from "../../scheduled/event_modal/Index.vue";

export default {
  name: "TripsModal",
  components: { GenericModal, GenericCalendar, GenericDropdown, EventModal },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.destination ||
        !v.meta.departure_date ||
        !v.meta.return_date ||
        !v.meta.driver_id ||
        !v.meta.vehicle_id
      );
    },
  },
  methods: {
    format_date_time,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(date) {
      let v = this;
      v.set_initial_state();

      get("/trip/requested-calendar", { date: date })
        .then((event) => {
          v.meta = event;
          v.$refs.generic_modal.show_modal();
          setTimeout(() => {
            event.map((item, iidx) => {
              if (item.assigned_scheduled_trip_id)
                v.$refs.trip_dropdown[iidx].set_value(
                  item.assigned_scheduled_trip_id
                );
            });
          }, 100);
        })
        .catch((error) => {
          error_message(error);
        });
    },
    // save() {
    //   let v = this;
    //   if (!v.meta.uuid)
    //     put("/trip/scheduled", v.meta)
    //       .then(() => {
    //         v.$emit("success");
    //         v.$refs.generic_modal.close_modal();
    //       })
    //       .catch((error) => {
    //         v.error = generate_error_message_text(error);
    //       });
    //   else
    //     post("/trip/scheduled", v.meta)
    //       .then(() => {
    //         v.$emit("success");
    //         v.$refs.generic_modal.close_modal();
    //       })
    //       .catch((error) => {
    //         v.error = generate_error_message_text(error);
    //       });
    // },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      // v.$refs.driver_dropdown.clear();
      // v.uuid = "";
    },
    assign_to_trip(requested_trip, scheduled_trip) {
      let v = this;
      console.log(requested_trip, scheduled_trip);
      if (
        requested_trip &&
        requested_trip.request_id &&
        scheduled_trip &&
        scheduled_trip.trip_id
      ) {
        let obj = {
          request_id: requested_trip.request_id,
          scheduled_id: scheduled_trip.trip_id,
        };

        put("/trip/requested-calendar", obj)
          .then((event) => {})
          .catch((error) => {
            error_message(error);
          });
      }
    },
    add_new_trip(item) {
      let v = this;
      v.$refs.event_modal.create_from_trip(item);
      // v.meta = item;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
